//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/BaseImporter.js";
let d=[[[0,"CanCreateSingleFeature",1,0],[0,"Cleanup",1,0],[0,"FileOpenFlag",1,0],[0,"ImportAs",1,0],[0,"ImportGroups",1,0],[0,"ImportTo",1,0],[0,"ImportToTeamcenter",1,0],[0,"ImportUnits",1,0],[0,"MergeSubdivisionBodyFacesIfPossible",1,0],[0,"Messages",1,0],[0,"ReverseNames",1,0],[0,"SettingsFile",1,0],[0,"ShowInformationWindowFlag",1,0]],[[["filename"],"SaveSettings",{},1,0]],[]];
SPLM.WavefrontObjImporter = class extends SPLM.BaseImporter{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.WavefrontObjImporter";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.WavefrontObjImporter.ImportAsOption = Object.freeze({
    "ConvergentGeometry" : "ConvergentGeometry", "SubdivisionGeometry" : "SubdivisionGeometry"});

SPLM.WavefrontObjImporter.ImportToOption = Object.freeze({
    "WorkPart" : "WorkPart", "NewPart" : "NewPart"});

SPLM.WavefrontObjImporter.GroupsEnum = Object.freeze({
    "NodeNames" : "NodeNames", "Assembly" : "Assembly", "Off" : "Off"});

SPLM.WavefrontObjImporter.UnitsEnum = Object.freeze({
    "Millimeters" : "Millimeters", "Inches" : "Inches", "Meters" : "Meters", "Centimeters" : "Centimeters", "Feet" : "Feet", "Microns" : "Microns"});

SPLM.WavefrontObjImporter.MessageEnum = Object.freeze({
    "None" : "None", "Informational" : "Informational", "Warning" : "Warning", "Error" : "Error", "Debug" : "Debug", "All" : "All"});

export default SPLM;